import { topliApi } from '@/shared/api/topli/TopliApi'
import { useQuery } from '@tanstack/react-query'
import { NotificationLogParams } from './model'

export const notificationLogQueryKey = 'notificationLog'

export const getNotificationLog = async ({ limit, offset, sort, search, user_id, events }) => {
  const requestParams: NotificationLogParams = {
    limit,
    offset,
    sort,
    user_id,
    client_name__icontains: search,
  }

  if (events?.length) {
    requestParams.event_type__in = events
  }

  const response = await topliApi.notificationLog.list(requestParams)
  return response
}

export const useNotificationLog = ({ sort, limit, offset, user_id, search, events }) =>
  useQuery({
    queryKey: [notificationLogQueryKey, sort, offset, limit, user_id, search || '', events],
    queryFn: () =>
      getNotificationLog({ sort, limit, offset, user_id, search: search || '', events }),
  })
